var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestStartedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 57,
    viewBox: "0 0 69 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6448 56.6146C67.3866 56.6146 67.9814 56.0158 67.9814 55.2746V18.9268H68.3647V55.2746C68.3647 56.2292 67.5985 57 66.6448 57H2.35508C1.40952 57 0.635254 56.2292 0.635254 55.2746V52.7427H1.01814V55.2746C1.01814 56.0158 1.6133 56.6146 2.35508 56.6146H66.6448ZM68.3647 18.9268H67.9814V1.71949C67.9814 0.978306 67.3866 0.379423 66.6448 0.379423H2.35508C1.6133 0.379423 1.01814 0.978306 1.01814 1.71949V10.6078H0.635254V1.71949C0.635254 0.770774 1.40952 0 2.35508 0H66.6448C67.5985 0 68.3647 0.770774 68.3647 1.71949V18.9268Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.01237 4.2423C4.60291 4.2423 5.08166 3.76358 5.08166 3.17303C5.08166 2.58248 4.60291 2.10376 4.01237 2.10376C3.42182 2.10376 2.94312 2.58248 2.94312 3.17303C2.94312 3.76358 3.42182 4.2423 4.01237 4.2423Z",
    fill: "#9E007E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87882 4.2423C8.46937 4.2423 8.94811 3.76358 8.94811 3.17303C8.94811 2.58248 8.46937 2.10376 7.87882 2.10376C7.28828 2.10376 6.80957 2.58248 6.80957 3.17303C6.80957 3.76358 7.28828 4.2423 7.87882 4.2423Z",
    fill: "#428DFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7453 4.2423C12.3358 4.2423 12.8146 3.76358 12.8146 3.17303C12.8146 2.58248 12.3358 2.10376 11.7453 2.10376C11.1547 2.10376 10.676 2.58248 10.676 3.17303C10.676 3.76358 11.1547 4.2423 11.7453 4.2423Z",
    fill: "#428DFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1764 5.98047H0.826416V6.36328H68.1764V5.98047Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4996 9.82355L17.1206 15.4875L24.2389 49.8965L51.6179 44.2325L44.4996 9.82355Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9149 37.3504C31.8063 38.2003 27.7867 35.5588 26.9368 31.4502C26.0868 27.3417 28.7284 23.322 32.837 22.4721C36.9455 21.6221 40.9651 24.2637 41.8151 28.3723C42.665 32.4808 40.0234 36.5004 35.9149 37.3504Z",
    fill: "#428DFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6534 33.9318C33.4143 34.2809 32.9303 34.381 32.5723 34.1555C32.5702 34.1542 29.5995 32.2824 29.5995 32.2824C29.2416 32.0569 29.1452 31.5911 29.3842 31.242C29.6233 30.893 30.1073 30.7928 30.4653 31.0184L32.7453 32.4549L36.7979 25.5985C37.0126 25.2352 37.4891 25.1043 37.8622 25.3061C38.2352 25.5079 38.3636 25.966 38.1489 26.3293L33.6845 33.8825C33.6748 33.8992 33.6645 33.9156 33.6534 33.9318Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5779 14.9827L19.6632 15.3949L17.4243 15.8581L24.456 49.8485L51.4325 44.2678L44.4008 10.2774L29.5619 13.3472L29.4766 12.9349L44.519 9.82304C44.63 9.80007 44.7395 9.8634 44.7651 9.98708L51.8821 44.3898C51.9076 44.5134 51.8323 44.615 51.7212 44.638L24.3379 50.3029C24.2268 50.3258 24.1174 50.2625 24.0918 50.1388L16.9748 15.7362C16.9492 15.6125 17.0246 15.5109 17.1356 15.4879L19.5779 14.9827Z",
    fill: "#151515"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01806 52.8316L1.01807 14.5186L0.635253 14.5186L0.635251 52.8316L1.01806 52.8316Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestStartedImg);
export default __webpack_public_path__ + "static/media/test-started-img.ba885f4a58b11867d0b92bda0e38c078.svg";
export { ForwardRef as ReactComponent };